import { createRoot } from 'react-dom/client';
import App from './App';
import './style.css';
import './mobile.css';
import './custom.css';

import { ApiErrorBoundaryProvider } from './hooks/ApiErrorBoundaryContext';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ApiErrorBoundaryProvider>
    <App />
  </ApiErrorBoundaryProvider>,
);
